import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setSearch } from "../store/slices/mentorsFiltersSlice";

export default function MentorSearch() {
  const dispatch = useDispatch();
  const search = useSelector((state: RootState) => state.mentorsFilters.search);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setSearch(e.target.value));
  };

  return (
    <input
      type="text"
      placeholder="חיפוש מלווה..."
      value={search}
      onChange={handleChange}
      className="h-10 px-4 rounded-xl border border-border bg-white text-sm focus:outline-none focus:ring-2 focus:ring-primary"
    />
  );
}
